<script>
import { mdiImage, mdiImageAlbum} from "@mdi/js";
import NewGallery from "@/views/website/NewGallery.vue";

export default {
  name: 'Gallery',
  components: {NewGallery},
  data() {
    return {
      subTabs: [
        { title: 'Galerie', icon: mdiImage },
        { title: 'Nouvelle galerie', icon: mdiImageAlbum },
      ],
      tab_content: null,
      galleryType: '',
      galleryAllType: [],
    }
  },
}
</script>

<template>
  <div >
    <v-tabs
        v-model="tab_content"
        show-arrows
        style="margin-bottom:1rem;"
    >
      <v-tab
          href="#tab-0"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[0].icon }}
        </v-icon>
        <span>{{ subTabs[0].title }}</span>
      </v-tab>
      <v-tab
          href="#tab-1"
      >
        <v-icon
            class="me-3"
            size="20"
        >
          {{ subTabs[1].icon }}
        </v-icon>
        <span>{{ subTabs[1].title }}</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab_content" style="padding: 0.98rem;">
      <v-tab-item :value="'tab-'+0">
        <v-row style="margin-top: 0.9rem;">
          <v-col>
            <v-select
                v-model="galleryType"
                dense
                :items="galleryAllType"
                label="Filtré par type de galerie"
                outlined
                item-value="id"
                item-text="serv_name"
            ></v-select>

          </v-col>
          <v-col>
            <span
                class="text-lg-h5  mb-4"
                style="justify-content: center; display: flex;"
            >
              Liste des galeries du site internet
            </span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
              v-for="n in 9"
              :key="n"
              class="d-flex child-flex"
              cols="4"
          >
            <v-img
                :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
                :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
                aspect-ratio="1"
                class="bg-grey-lighten-2"
                cover
            >
              <template v-slot:placeholder>
                <v-row
                    align="center"
                    class="fill-height ma-0"
                    justify="center"
                >
                  <v-progress-circular
                      color="grey-lighten-5"
                      indeterminate
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
        </v-row>
      </v-tab-item>
      <v-tab-item :value="'tab-'+1">
        <NewGallery></NewGallery>
      </v-tab-item>
    </v-tabs-items>
  </div>

</template>

<style scoped>

</style>